import React, { useContext, useEffect, useState } from "react";
import { SessionContext, initialState } from "../../Session";
import styled from "styled-components";
import { navigate } from "gatsby";
import Cleave from "cleave.js/react";
// import Shimmer from "../../../components/smallShimmer";
// import sendDoorPass from "../actions/sendDoorPass";
// import getMemberList from "../actions/getMemberList";
// import requestWeekPass from '../actions/requestWeekPass';


const PasswordBox = styled.div`
  padding-right: 2em;
  padding-bottom: 1em;
`;


function updateStaffPassword(password, dispatch) {
  password = password.replace(/\D/g, "");
  console.log(password)
  dispatch(({
    type: "STAFF_INPUT_PASSWORD",
    password: password
  }))
  return true;
}

function LoginComponent() {
  const { session, dispatch } = useContext(SessionContext) || {
    session: initialState
  };
  const [passwordInput, setPasswordInput] = useState(null);

  useEffect(() => {
      if(passwordInput) {
        passwordInput.focus();
      } else {
      }
  }, [passwordInput]);

  return (
            <PasswordBox>
                <Cleave
                    htmlRef={(ref)=>{setPasswordInput(ref)}}
                    value={session.staff.password}
                    type="password"
                    className={`input is-large ${session.staff.inputClass}`}
                    options={{
                      numericOnly: true,
                      blocks: [4],
                      delimiters: []
                    }}
                    id="staff_login_password"
                    onChange={e => {
                      updateStaffPassword(e.target.value, dispatch);
                    }}
                  />

              {session.staff.login_message}              
            </PasswordBox>
  );
}

export default LoginComponent;
